import styled from "styled-components";
import { Colors } from "@smartsuite/types";

export const StyledSection = styled.div`
  gap: 15px;
  padding: 6px 15px;
  margin-bottom: 18px;
  border-radius: 8px;
  display: flex;
  min-height: 54px;
  background: ${Colors.dwRed};
  align-items: center;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: left;
  gap: 5px;
  color: ${Colors.dRed};
`;

export const MessageItem = styled.span`
  display: flex;
  font-size: 13px;
  word-break: break-word;
`;

export const EditorType = styled.code`
  font-family: monospace;
  font-weight: 600;
`;
